import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';
import { RootState } from '../store';
import { InitialTag, setNewTagData, setUploadTagProgress } from '../slices/tag';
import { AxiosProgressEvent, AxiosRequestConfig, AxiosResponse } from 'axios';

export const getTypeOfTags = createAsyncThunk('tag/get-types', async (_, { getState }) => {
    const state = getState() as RootState;
    const { activeTeam, teams } = state.team;

    const response = await axios.get('pois/types-v2');

    // console.log('response', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return teams.some((v) => v.id === activeTeam) || !activeTeam
            ? response.data.data
            : response.data.data.filter(
                  (v: { type: string }) => !['hunting_cabine', 'hunting_tower', 'hunting_stand'].includes(v.type),
              );
        // return response.data.data;
    } else {
        throw 'error';
    }
});

export const createTag = createAsyncThunk('tag/create', async ({ formData }: { formData: FormData }, { dispatch }) => {
    try {
        const config: AxiosRequestConfig = {
            onUploadProgress: function (progressEvent: AxiosProgressEvent) {
                const percentage = Math.round((progressEvent.loaded * 100) / (progressEvent?.total ?? 1));
                dispatch(setUploadTagProgress(percentage));
            },
        };

        const response = await axios.post<AxiosResponse>(`pois?aws=1`, formData, config);
        // console.log('createTag', response.data);
        dispatch(setUploadTagProgress(0));
        return response.data;
    } catch (error) {
        console.log('createTag e', error);
        dispatch(setUploadTagProgress(0));
        throw error;
    }
});

export const updataTag = createAsyncThunk(
    'tag/update',
    async ({ id, formData }: { id: number; formData: FormData }, { dispatch }) => {
        try {
            const config: AxiosRequestConfig = {
                onUploadProgress: function (progressEvent: AxiosProgressEvent) {
                    const percentage = Math.round((progressEvent.loaded * 100) / (progressEvent?.total ?? 1));
                    dispatch(setUploadTagProgress(percentage));
                },
            };

            const response = await axios.post<AxiosResponse>(`pois/${id}?aws=1`, formData, config);
            dispatch(setUploadTagProgress(0));
            return response.data;
        } catch (error) {
            dispatch(setUploadTagProgress(0));
            throw error;
        }
    },
);

export const deleteTag = createAsyncThunk('tag/delete', async ({ id }: { id: number }) => {
    const response = await axios.delete(`pois/${id}?aws=1`);

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const getTypeOfBirds = createAsyncThunk('tag/birds', async () => {
    const response = await axios.get('pois/types/bird');

    // console.log('getTypeOfBirds', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getTypeOfMammals = createAsyncThunk('tag/mammals', async () => {
    const response = await axios.get('pois/types/mammal');

    // console.log('getTypeOfMammals', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const setNewTagDataInitial = createAsyncThunk('tag/initial', async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { lat, lng } = state.map.region;
    dispatch(setNewTagData({ ...InitialTag, latitude: lat, longitude: lng }));
});

export const clearNewTagData = createAsyncThunk('tag/clear', async (_, { dispatch }) => {
    dispatch(setNewTagData(InitialTag));
});
